module.exports = __webpack_public_path__ + "decb4635129cbda961fe43f7caa442c7.png";